import React from 'react';
import { Dropdown, Flex, Tooltip } from 'antd';
import {
    EyeOutlined,
    MoreOutlined,
    EyeInvisibleOutlined,
} from '@ant-design/icons';

import { useTheme } from 'hooks/useTheme';

import {
    AttributesDropdownProps,
    AttributesProps,
} from '../service/attributes.interface';
import {
    useCreatePositionMutation,
    useCreateVisibilityMutation,
} from '../service/attributes';
import { dropdownItems } from '../utils/options';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

interface Props extends AttributesProps {
    maxPosition: number;
}

export const AttributesActions = ({ is_visible, maxPosition, id }: Props) => {
    const current = useAppSelector(selectShopCurrent);

    const [createVisibility, { isLoading }] = useCreateVisibilityMutation();
    const [createPosition] = useCreatePositionMutation();

    const { colorIcon, colorPrimary } = useTheme();

    const changePosition = (item: AttributesDropdownProps) => {
        const payload = {
            shop_id: current.id,
            id: id,
            position: item.key === 'to-start' ? 1 : maxPosition,
        };
        createPosition(payload);
    };

    const changeVisibility = (
        e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
        id: number,
        is_visible: boolean
    ) => {
        e.preventDefault();
        const payload = {
            shop_id: current.id,
            id: id,
            is_visible: !is_visible,
        };

        createVisibility(payload);
    };

    const iconStyle = {
        color: is_visible ? colorPrimary : colorIcon,
        fontSize: '20px',
        cursor: isLoading ? 'progress' : 'pointer',
    };

    const menuProps = {
        items: dropdownItems.map(item => ({
            key: item.key,
            label: item.label,
            onClick: () => changePosition(item),
        })),
    };

    const tooltipTitle = is_visible
        ? 'Скрыть характеристику'
        : 'Отображать характеристику';
    const EyeIcon = is_visible ? EyeOutlined : EyeInvisibleOutlined;

    return (
        <Flex gap={10}>
            <Tooltip title={tooltipTitle}>
                <EyeIcon
                    disabled={isLoading}
                    onClick={e => changeVisibility(e, id, is_visible)}
                    style={iconStyle}
                />
            </Tooltip>

            <Dropdown
                disabled={isLoading}
                trigger={['click']}
                placement={'bottomLeft'}
                menu={menuProps}
            >
                <MoreOutlined disabled={isLoading} style={iconStyle} />
            </Dropdown>
        </Flex>
    );
};
